export const PLAN_TYPE_MAP = { A: 'revenueShare', B: 'hybrid' };

export const getCidPricing = (pricingData, uploader, cidPlan) => {
  if (!pricingData) return null;
  const uploaderKey = uploader === 'self' ? 'self' : 'redflag';
  const planKey = PLAN_TYPE_MAP[cidPlan] || 'revenueShare';
  return pricingData.rules.youtubeCid[uploaderKey][planKey];
};

export const getCidLabel = (pricingData, cidPlan) => {
  if (!pricingData) return '';
  const planKey = PLAN_TYPE_MAP[cidPlan] || 'revenueShare';
  return pricingData.display.planLabels[planKey];
};

export const getUploaderLabel = (pricingData, uploader) => {
  if (!pricingData) return '';
  return pricingData.display.uploaderLabels[uploader];
};

export const getChannelLimit = (accountKind) => (accountKind === 'agency' ? 100 : 2);

export const getSocialMonthly = (pricingData, offerings, socialPlatforms, channelCount = 1) => {
  const perPlatform = pricingData?.rules.socialScanning.perPlatformMonthlyFeeAmount ?? 0;
  return offerings.useSocial ? perPlatform * (socialPlatforms.length || 1) * channelCount : 0;
};

export const getEarlyBirdCidSetupFee = (pricingData, uploader, cidPlan) => {
  if (!pricingData) return null;
  const uploaderKey = uploader === 'self' ? 'self' : 'redflag';
  const planKey = PLAN_TYPE_MAP[cidPlan] || 'revenueShare';
  return pricingData.rules.youtubeCid[uploaderKey][planKey]?.earlyBirdSetupFeeAmount ?? null;
};
